import { APP } from '../../redux/constants/app.constants';

export const ACCOUNT_PAGE = `${APP}/ACCOUNT_PAGE`;

export const DELETE_ACCOUNT = `${ACCOUNT_PAGE}/DELETE_ACCOUNTS`;
export const ACCOUNT_EDIT = `${ACCOUNT_PAGE}/ACCOUNT_EDIT`;
export const LOGIN_ACCOUNT = `${ACCOUNT_PAGE}/LOGIN_ACCOUNT`;
export const ARCHIVE_ACCOUNT = `${ACCOUNT_PAGE}/ARCHIVE_ACCOUNT`;
export const CREATE_TRIAL_ACCOUNT = `${ACCOUNT_PAGE}/CREATE_TRIAL_ACCOUNT`;
